var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"item",on:{"click":function($event){return _vm.click(item)}}},[_c('div',[_vm._v(_vm._s(item.name))]),_vm._m(0,true)])}),0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("@/assets/img/next.svg"),"alt":""}})])
}]

export { render, staticRenderFns }